import { createRouter, createWebHistory } from 'vue-router'
import IndexView from '../views/IndexView.vue'
import MyBotView from '@/views/mainTabs/MyBotView.vue'

const routes = [
    {
        path: '/',
        name: 'index',
        component: IndexView,
        redirect: '/home',
        children: [
            {
                path: '/home',
                name: 'home',
                component: () => import(/* webpackChunkName: "about" */ '../views/mainTabs/HomeView.vue')
            },
            {
                path: '/mybot',
                name: 'mybot',
                component: MyBotView,
                meta: { requiresAuth: true }
            },
            {
                path: '/me',
                name: 'me',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '../views/mainTabs/MeView.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/observation',
                name: 'observation',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '../views/mainTabs/ObservationView.vue')
            }
        ]
    }, {
        path: '/indexprofit',
        name: 'indexprofit',
        component: () => import(/* webpackChunkName: "about" */ '../views/IndexProfitView.vue'),
        children: [
            {
                path: '/profitoverview',
                name: 'profitoverview',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '../views/ProfitOverviewView.vue')
            },
            {
                path: '/profitdetails',
                name: 'profitdetails',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '../views/ProfitDetailsView.vue')
            },
        ]
    },
    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    },
    {
        path: '/addnewbot',
        name: 'addnewbot',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AddNewBot.vue')
    }, {
        path: '/profitdetailslist',
        name: 'profitdetailslist',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/ProfitDetailsListView.vue')
    },
    {
        path: '/login',
        name: 'login',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/LoginView.vue')
    },
    {
        path: '/accountbind',
        name: 'accountbind',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AccountBindView.vue')
    },
    {
        path: '/switchpricecurrency',
        name: 'switchpricecurrency',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/SwitchPriceCurrency.vue')
    },
    {
        path: '/switchsymbolstyle',
        name: 'switchsymbolstyle',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/SwitchSymbolStyle.vue')
    },
    {
        path: '/authidentity',
        name: 'authidentity',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AuthIdentityView.vue')
    },
    {
        path: '/messageshow',
        name: 'messageshow',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/pages/MessageShowPage.vue')
    },
    {
        path: '/homedetails',
        name: 'homedetails',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/HomeDetailsView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/pushsettings',
        name: 'pushsettings',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/PushSettingsView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/selectpushbot',
        name: 'selectpushbot',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/SelectPushBotView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/test',
        name: 'test',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/test.vue'),
        meta: { requiresAuth: false }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
